
function runStickyFilterBarAndPills() {
  var filterBar = document.querySelector('.ais-search-header');
  var pillsWrapper = document.querySelector('.filter-pills-wrapper');
  if (!filterBar || !pillsWrapper) return;

  // Sentinel for sticky logic
  var sentinel = document.createElement('div');
  sentinel.style.width = '100%';
  sentinel.style.height = '1px';
  filterBar.parentNode.insertBefore(sentinel, filterBar);

  // Helper to get current sticky header height and rootMargin
  function getStickyConfig() {
    var isMobile = window.innerWidth <= 768;
    return {
      headerHeight: isMobile ? 70 : 119,
      rootMargin: isMobile ? '-70px 0px 0px 0px' : '-119px 0px 0px 0px'
    };
  }
  var placeholder = null;
  var pillsPlaceholder = null;

  function ensurePlaceholder() {
    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.className = 'ais-search-header-placeholder';
      filterBar.parentNode.insertBefore(placeholder, filterBar);
    }
    placeholder.style.height = filterBar.offsetHeight + 'px';
  }

  function removePlaceholder() {
    if (placeholder && placeholder.parentNode) {
      placeholder.parentNode.removeChild(placeholder);
      placeholder = null;
    }
  }

  function ensurePillsPlaceholder() {
    if (!pillsPlaceholder) {
      pillsPlaceholder = document.createElement('div');
      pillsPlaceholder.className = 'filter-pills-wrapper-placeholder';
      pillsWrapper.parentNode.insertBefore(pillsPlaceholder, pillsWrapper);
    }
    pillsPlaceholder.style.height = pillsWrapper.offsetHeight + 'px';
  }

  function removePillsPlaceholder() {
    if (pillsPlaceholder && pillsPlaceholder.parentNode) {
      pillsPlaceholder.parentNode.removeChild(pillsPlaceholder);
      pillsPlaceholder = null;
    }
  }


  var observer = null;
  function updateSticky() {
    var config = getStickyConfig();
    var plpHeaderHeight = config.headerHeight;
    var pillsContainer = pillsWrapper.querySelector('.ais-filter-pills-container');
    var pillsHasContent = pillsContainer && pillsContainer.children.length > 0;
    var entryTop = sentinel.getBoundingClientRect().top;
    if (entryTop < plpHeaderHeight) {
      ensurePlaceholder();
      filterBar.classList.add('is-fixed');
      if (pillsHasContent) {
        ensurePillsPlaceholder();
        pillsWrapper.classList.add('is-fixed');
        filterBar.classList.add('with-pills-fixed');
      } else {
        pillsWrapper.classList.remove('is-fixed');
        removePillsPlaceholder();
        filterBar.classList.remove('with-pills-fixed');
      }
    } else {
      filterBar.classList.remove('is-fixed');
      removePlaceholder();
      pillsWrapper.classList.remove('is-fixed');
      removePillsPlaceholder();
      filterBar.classList.remove('with-pills-fixed');
    }
  }

  function createObserver() {
    if (observer) observer.disconnect();
    var config = getStickyConfig();
    observer = new window.IntersectionObserver(
      function (entries) {
        if (!entries.length) return;
        updateSticky();
      },
      {
        root: null,
        threshold: [0],
        rootMargin: config.rootMargin
      }
    );
    observer.observe(sentinel);
  }
  createObserver();

  // Global pillsContainer reference
  var pillsContainer = '';
  function observePillsContainer() {
    pillsContainer = pillsWrapper.querySelector('.ais-filter-pills-container');
    if (pillsContainer) {
      new MutationObserver(updateSticky).observe(pillsContainer, { childList: true });
    }
  }
  observePillsContainer();
  // Watch for pills container being added
  new MutationObserver(function () {
    observePillsContainer();
    updateSticky();
  }).observe(pillsWrapper, { childList: true });

  window.addEventListener('resize', function () {
    if (filterBar.classList.contains('is-fixed') && placeholder) {
      placeholder.style.height = filterBar.offsetHeight + 'px';
    }
    if (pillsWrapper.classList.contains('is-fixed') && pillsPlaceholder) {
      pillsPlaceholder.style.height = pillsWrapper.offsetHeight + 'px';
    }
    createObserver();
    updateSticky();
  });

  updateSticky();
}

document.addEventListener('DOMContentLoaded', function () {
  function tryInit() {
    if (document.querySelector('.ais-search-header') && document.querySelector('.filter-pills-wrapper')) {
      runStickyFilterBarAndPills();
      return true;
    }
    return false;
  }
  if (tryInit()) return;
  var observer = new MutationObserver(function () {
    if (tryInit()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});